import * as api from './DrugApi';
import { messages } from '../../lang/en';
import * as type from './DrugType';
import { getNamespace } from '../../utils/storage';
import { bodyReq } from '../../utils/bodyRequest';

export const setDrugs = (state, prescriptionId) => ({
    type: type.SET_DRUGS,
    payload: {
        data: state,
        key: prescriptionId
    }
});
export const addPrescription = (state) => ({
    type: type.ADD_PRESCRIPTION,
    payload: state
});

export const getAllPrescriptions =
    (patientId, service = api.getAllPrescriptionOfPatient) =>
    async (dispatch) => {
        dispatch({
            type: type.SET_PRESCRIPTIONS.REQUEST
        });
        const namespace = getNamespace();
        return await service(patientId, namespace)?.then((response) => {
            dispatch({
                type: type.SET_PRESCRIPTIONS.SUCCESS,
                payload: response?.data?.prescriptions
            });
        });
    };
export const searchDrugs =
    (name, prescriptionId, service = api.searchDrugs) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service({ name, namespace }).then((response) => {
            dispatch(setDrugs(response?.data?.drugs, prescriptionId));
        });
    };
export const createPrescription =
    (prescription, service = api.createPrescription) =>
    (dispatch) => {
        const body = bodyReq(prescription);
        return service(body).then((response) => {
            dispatch(addPrescription(response.data));
            return dispatch({
                type: 'ADD_MESSAGE',
                patient: response.data,
                payload: {
                    text: messages.postActionAlert.prescriptionAdded,
                    status: response.status
                }
            });
        });
    };
export const editPrescription =
    (id, prescription, service = api.editPrescription) =>
    async (dispatch) => {
        const body = bodyReq(prescription);
        return await service(id, body).then((response) => {
            dispatch({
                type: type.REPLACE_PRESCRIPTION,
                payload: {
                    data: response.data,
                    id
                }
            });
            dispatch({
                type: 'ADD_MESSAGE',
                prescription: response.data,
                payload: {
                    text: messages.postActionAlert.prescriptionEdited,
                    status: response.status
                }
            });
        });
    };
export const deletePrescription =
    (id, service = api.deletePrescription) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(id, namespace).then((response) => {
            dispatch({
                type: type.REMOVE_PRESCRIPTION,
                payload: id
            });
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: messages.postActionAlert.prescriptionDeleted,
                    status: response.status
                }
            });
        });
    };
export const getDrugsDetail =
    (ids, prescriptionId, service = api.getDrugsDetail) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(ids, namespace)?.then((response) => {
            dispatch(setDrugs(response?.data?.drugs, prescriptionId));
        });
    };
